// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "header .container-fluid.container-fluid[data-v-75af44a4]{position:absolute;top:0;z-index:2}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
